import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-commonpop',
  templateUrl: './commonpop.component.html',
  styleUrls: ['./commonpop.component.scss']
})
export class CommonpopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
